if (navigator.userAgent.includes('Safari') && navigator.userAgent.includes('Mobile') && !navigator.userAgent.includes('Chrome')) {
  document.body.classList.add('safari-mobile');
}

document.addEventListener('DOMContentLoaded', () => {
  const stickyBtn = document.querySelector('#sticky-element.jci-sticky-element button[name="checkout"]');
  const originalBtn = document.querySelector('#sticky-element:not(.jci-sticky-element) button[name="checkout"]');
  if (stickyBtn && originalBtn) {
    stickyBtn.addEventListener('click', (e) => { e.preventDefault(); originalBtn.click(); });
  }

  if (document.body.classList.contains('template-cart')) {
    const stickyEl = document.querySelector('.jci-sticky-element');
    const targetEl = document.querySelector('.template-cart .shopify-section.index-section');
    if (stickyEl && targetEl) targetEl.parentNode.insertBefore(stickyEl, targetEl);
  }

  if (document.body.classList.contains('template-cart')) {
    const stickyElement = document.querySelector('.jci-sticky-element');
    const stickyOffset = stickyElement.offsetTop - 47;
    window.addEventListener('scroll', () => {
      stickyElement.classList.toggle('jci-sticky-active', window.scrollY >= stickyOffset);
    });
  }

  document.querySelectorAll('.site-nav__link, .mobile-nav__link--top-level').forEach(function(el) {
    if (el.textContent.trim().toUpperCase() === 'SALE') el.classList.add('jci-nav-sale');
  });

  // =====================
  // Swipe carousel (collection grid)
  // Skips tiles inside product-recommendations or recently-viewed sections
  // =====================
  function initSwipeCarousels() {
    document.querySelectorAll('.jci-swipe:not([data-swipe-init])').forEach(function(el) {
      if (el.closest('[data-section-type="product-recommendations"]') ||
          el.closest('[data-section-type="recently-viewed"]') ||
          el.closest('product-recommendations')) {
        el.setAttribute('data-swipe-init', '1');
        return;
      }
      el.setAttribute('data-swipe-init', '1');
      var overlay = el.querySelector('.jci-swipe__overlay');
      var track = el.querySelector('.jci-swipe__track');
      var dots = el.querySelectorAll('.jci-swipe__dot');
      var slideCount = el.querySelectorAll('.jci-swipe__slide').length;
      if (!overlay || !track || slideCount < 2) return;

      var index = 0, startX = 0, startY = 0, dragDelta = 0, totalMovement = 0, isHorizontal = null;
      var THRESHOLD = 50, AXIS_LOCK = 12, TAP_MAX = 8;
      var productUrl = el.dataset.productUrl;

      function goTo(i) {
        index = Math.max(0, Math.min(i, slideCount - 1));
        track.style.transition = 'transform 0.35s ease';
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        dots.forEach(function(d, di) { d.classList.toggle('jci-swipe__dot--active', di === index); });
      }
      overlay.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
        dragDelta = 0; totalMovement = 0; isHorizontal = null;
      }, { passive: true });
      overlay.addEventListener('touchmove', function(e) {
        var dx = e.touches[0].clientX - startX, dy = e.touches[0].clientY - startY;
        totalMovement = Math.max(Math.abs(dx), Math.abs(dy));
        if (isHorizontal === null) {
          if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) return;
          isHorizontal = Math.abs(dx) >= Math.abs(dy);
        }
        if (!isHorizontal) return;
        e.preventDefault();
        dragDelta = dx;
        var pct = -(index * 100) + (dragDelta / el.offsetWidth * 100);
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + pct + '%)';
      }, { passive: false });
      overlay.addEventListener('touchend', function() {
        var isTap = totalMovement <= TAP_MAX;
        if (isTap) { if (productUrl) window.location.href = productUrl; return; }
        if (!isHorizontal) return;
        if (dragDelta < -THRESHOLD) goTo(index + 1);
        else if (dragDelta > THRESHOLD) goTo(index - 1);
        else goTo(index);
        dragDelta = 0;
      });
      var isDragging = false, mouseDidSwipe = false;
      overlay.addEventListener('mousedown', function(e) {
        isDragging = true; startX = e.clientX; dragDelta = 0; mouseDidSwipe = false;
        overlay.classList.add('is-dragging'); e.preventDefault();
      });
      window.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        dragDelta = e.clientX - startX;
        if (Math.abs(dragDelta) > TAP_MAX) mouseDidSwipe = true;
        var pct = -(index * 100) + (dragDelta / el.offsetWidth * 100);
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + pct + '%)';
      });
      window.addEventListener('mouseup', function() {
        if (!isDragging) return;
        isDragging = false; overlay.classList.remove('is-dragging');
        if (!mouseDidSwipe) { if (productUrl) window.location.href = productUrl; }
        else if (dragDelta < -THRESHOLD) goTo(index + 1);
        else if (dragDelta > THRESHOLD) goTo(index - 1);
        else goTo(index);
        dragDelta = 0;
      });
    });
  }

  // =====================
  // Hint animation — collection grid
  // Matches PDP timing (400ms delay). First tile nudges, then second tile.
  // Skips tiles inside recommendations/recently-viewed
  // =====================
  function runSwipeHint() {
    var allSwipes = Array.from(document.querySelectorAll('.jci-swipe')).filter(function(el) {
      return !el.closest('product-recommendations') &&
             !el.closest('[data-section-type="recently-viewed"]');
    });
    if (!allSwipes.length) return;

    function nudgeTile(el, delay) {
      var hintTrack = el.querySelector('.jci-swipe__track');
      var hintSlides = el.querySelectorAll('.jci-swipe__slide');
      if (!hintTrack || hintSlides.length < 2) return;
      hintTrack.style.transition = 'none';
      hintTrack.style.transform = 'translateX(0)';
      setTimeout(function() {
        var nudge = el.offsetWidth * 0.18;
        hintTrack.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        hintTrack.style.transform = 'translateX(-' + nudge + 'px)';
        setTimeout(function() {
          hintTrack.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
          hintTrack.style.transform = 'translateX(0)';
        }, 420);
      }, delay);
    }

    // First tile at 400ms, second tile at 400 + 420 + 200 = 1020ms
    nudgeTile(allSwipes[0], 400);
    if (allSwipes[1]) nudgeTile(allSwipes[1], 1020);
  }

  // =====================
  // Sizes left — collection grid overlay
  // Shows the size badge only for a stationary press. The badge is NOT
  // shown immediately on touchstart — it waits a short beat first, so a
  // horizontal swipe never gets the chance to flash it on before being
  // detected and cancelled. Vertical movement (page scroll while resting
  // a finger on the image) does not cancel it. Hides on release either
  // way. Delegated at the document level so it keeps working after
  // collection re-renders/infinite scroll without needing re-init.
  // Desktop hover is handled entirely in CSS.
  // =====================
  function initSizesLeftTouch() {
    var active = null;
    var startX = 0, startY = 0, cancelled = false, showTimer = null;
    var AXIS_LOCK = 10;
    var SHOW_DELAY = 130; // ms — long enough for a swipe to reveal itself, short enough to feel instant for a hold

    function clearActive() {
      if (showTimer) { clearTimeout(showTimer); showTimer = null; }
      if (active) active.classList.remove('jci-sizes-touching');
      active = null;
    }

    document.addEventListener('touchstart', function(e) {
      var wrapper = e.target.closest('.grid__item-image-wrapper');
      if (!wrapper || !wrapper.querySelector('.jci-sizes-left')) return;
      if (active && active !== wrapper) clearActive();
      active = wrapper;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      cancelled = false;
      var target = wrapper;
      showTimer = setTimeout(function() {
        if (!cancelled && active === target) target.classList.add('jci-sizes-touching');
      }, SHOW_DELAY);
    }, { passive: true });

    document.addEventListener('touchmove', function(e) {
      if (!active || cancelled) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (Math.abs(dx) > AXIS_LOCK && Math.abs(dx) >= Math.abs(dy)) {
        cancelled = true;
        clearActive();
      }
    }, { passive: true });

    document.addEventListener('touchend', clearActive, { passive: true });
    document.addEventListener('touchcancel', clearActive, { passive: true });
  }

  // =====================
  // Product page — mobile bar indicators
  // =====================
  function initProductBars() {
    if (window.innerWidth >= 768) return;
    var barsEl = document.querySelector('[data-product-bars]');
    if (!barsEl) return;
    var bars = barsEl.querySelectorAll('.jci-product-bar');
    if (!bars.length) return;
    function setActive(index) {
      bars.forEach(function(b, i) { b.classList.toggle('jci-product-bar--active', i === index); });
    }
    var slideshow = document.querySelector('.product-slideshow');
    if (!slideshow) return;
    slideshow.addEventListener('select.flickity', function() {
      var flkty = slideshow.querySelector('.flickity-slider');
      if (flkty) {
        var selected = flkty.querySelector('.is-selected');
        if (selected) { setActive(parseInt(selected.dataset.flickityIndex || selected.dataset.index || 0, 10)); return; }
      }
      slideshow.querySelectorAll('.product-main-slide, [data-index]').forEach(function(slide, i) {
        if (slide.classList.contains('is-selected') || slide.classList.contains('is-active')) setActive(i);
      });
    });
    document.addEventListener('theme:product:media-select', function(e) {
      if (e.detail && typeof e.detail.index !== 'undefined') setActive(e.detail.index);
    });
    var slideObserver = new MutationObserver(function() {
      slideshow.querySelectorAll('.product-main-slide, .flickity-slider > *').forEach(function(slide, i) {
        if (slide.classList.contains('is-selected')) setActive(i);
      });
    });
    slideObserver.observe(slideshow, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  // =====================
  // Product page — mobile swipe hint animation (fires at 400ms)
  // =====================
  function runProductSwipeHint() {
    if (window.innerWidth >= 768) return;
    var slideshow = document.querySelector('.product-slideshow');
    if (!slideshow) return;
    var slides = slideshow.querySelectorAll('.product-main-slide, .flickity-slider > *');
    if (slides.length < 2) return;
    setTimeout(function() {
      var nudge = slideshow.offsetWidth * 0.14;
      slideshow.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      slideshow.style.transform = 'translateX(-' + nudge + 'px)';
      setTimeout(function() {
        slideshow.style.transition = 'transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        slideshow.style.transform = 'translateX(0)';
        setTimeout(function() { slideshow.style.transition = ''; slideshow.style.transform = ''; }, 500);
      }, 420);
    }, 400);
  }

  // =====================
  // Sticky Add to Bag bar (PDP)
  // Mirrors the real Add to Bag button's label/disabled state and price;
  // clicking it simply triggers the real button so existing variant
  // selection, AJAX cart, and sold-out handling apply unchanged.
  // =====================
  function initStickyAddToCart() {
    var bar = document.querySelector('[data-jci-sticky-atc]');
    if (!bar) return;

    var form = document.querySelector('#MainContent .product-single__form');
    var realBtn = form ? form.querySelector('[data-add-to-cart]') : null;
    var realBtnText = realBtn ? realBtn.querySelector('[data-add-to-cart-text]') : null;
    var realPrice = document.querySelector('#MainContent [data-product-price]');
    var realComparePrice = document.querySelector('#MainContent [data-compare-price]');

    var stickyBtn = bar.querySelector('[data-jci-sticky-add-to-cart]');
    var stickyBtnText = bar.querySelector('[data-jci-sticky-add-to-cart-text]');
    var stickyPrice = bar.querySelector('[data-jci-sticky-price]');
    var stickyComparePrice = bar.querySelector('[data-jci-sticky-compare]');

    if (!form || !realBtn || !stickyBtn) return;

    // Multi-variant products get a size drawer instead of adding the
    // theme's default (smallest) size silently. Single-variant products
    // keep the direct scroll+click behaviour. Derived straight from how
    // many size buttons our own modal actually rendered (a single,
    // uniquely-identified element), rather than cross-checking a second
    // lookup that could mismatch.
    var sizeModal = document.querySelector('[data-jci-sticky-size-modal]');
    var sizeOptionButtons = sizeModal ? sizeModal.querySelectorAll('[data-jci-sticky-size-value]') : [];
    var needsSizeSelection = sizeOptionButtons.length > 1;

    function openSizeModal() {
      if (!sizeModal) return;
      sizeModal.setAttribute('aria-hidden', 'false');
    }
    function closeSizeModal() {
      if (!sizeModal) return;
      sizeModal.setAttribute('aria-hidden', 'true');
    }
    if (sizeModal) {
      sizeModal.querySelectorAll('[data-jci-sticky-size-close]').forEach(function(el) {
        el.addEventListener('click', closeSizeModal);
      });
      sizeModal.querySelectorAll('[data-jci-sticky-size-value]').forEach(function(sizeBtn) {
        sizeBtn.addEventListener('click', function() {
          if (sizeBtn.disabled) return;
          var value = sizeBtn.getAttribute('data-jci-sticky-size-value');
          var variantId = sizeBtn.getAttribute('data-jci-sticky-size-variant-id');
          var input = form.querySelector('[data-variant-input][value="' + CSS.escape(value) + '"]');
          var label = input ? form.querySelector('label[for="' + input.id + '"]') : null;
          // Click the real label, not just check the input, so the theme's
          // own change handlers fire exactly as they would for a real tap
          // (updates current variant, price, sold-out state, etc).
          if (label) {
            label.click();
          } else if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          // Safety net: set the form's actual submitted variant id field
          // directly too, in case the theme's own sync from the radio
          // click hasn't completed by the time we trigger Add to Bag.
          var idField = form.querySelector('select[name="id"], input[name="id"]');
          if (idField && variantId) {
            idField.value = variantId;
            idField.dispatchEvent(new Event('change', { bubbles: true }));
          }
          closeSizeModal();
          window.setTimeout(function() {
            if (!realBtn.disabled) realBtn.click();
          }, 60);
        });
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeSizeModal();
      });
    }

    stickyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (realBtn.disabled) return;
      if (needsSizeSelection && sizeModal) {
        openSizeModal();
        return;
      }
      // Scroll the real buy-buttons block into view first. If a size still
      // needs to be picked, the theme's native validation/error appears right
      // there where the customer can see and act on it; if not, the click
      // proceeds straight into the existing AJAX add-to-cart flow.
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(function() { realBtn.click(); }, 350);
    });

    var mediaBtn = bar.querySelector('[data-jci-sticky-scroll-top]');
    if (mediaBtn) {
      mediaBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    function syncButtonState() {
      stickyBtn.disabled = realBtn.disabled;
      if (realBtnText && stickyBtnText) {
        stickyBtnText.textContent = realBtnText.textContent.trim();
      }
    }
    function syncPrice() {
      if (realPrice && stickyPrice) stickyPrice.textContent = realPrice.textContent.trim();
      if (stickyComparePrice) {
        if (realComparePrice && realComparePrice.textContent.trim()) {
          stickyComparePrice.textContent = realComparePrice.textContent.trim();
          stickyComparePrice.style.display = '';
        } else {
          stickyComparePrice.style.display = 'none';
        }
      }
    }

    syncButtonState();
    syncPrice();

    var btnObserver = new MutationObserver(syncButtonState);
    btnObserver.observe(realBtn, { attributes: true, attributeFilter: ['disabled'] });
    if (realBtnText) {
      var textObserver = new MutationObserver(syncButtonState);
      textObserver.observe(realBtnText, { childList: true, characterData: true, subtree: true });
    }
    if (realPrice) {
      var priceObserver = new MutationObserver(syncPrice);
      priceObserver.observe(realPrice, { childList: true, characterData: true, subtree: true });
      if (realComparePrice) priceObserver.observe(realComparePrice, { childList: true, characterData: true, subtree: true });
    }

    // Show as soon as the visible button clears the viewport. We check
    // slightly before the wrapping block's true bottom edge (which includes
    // Shopify's injected "more payment options" text/margin below the
    // button) so the bar appears the instant the button itself disappears,
    // not after that trailing text has scrolled off too.
    var trigger = form.querySelector('.payment-buttons') || form;
    var EARLY_TRIGGER_PX = 60;
    function updateStickyVisibility() {
      var rect = trigger.getBoundingClientRect();
      var isPast = rect.bottom <= EARLY_TRIGGER_PX;
      bar.classList.toggle('is-visible', isPast);
      bar.setAttribute('aria-hidden', isPast ? 'false' : 'true');
    }

    // The bar carries a hard `hidden` attribute in the HTML so it cannot
    // render at all — not even briefly. Rather than trying to detect
    // exactly when the page has "settled" (images/fonts/widgets loading
    // in kept resetting that detection and causing repeated flicker),
    // simply wait a fixed, generous delay before ever checking or
    // revealing it at all. By 1.2s virtually everything has loaded.
    window.setTimeout(function() {
      bar.hidden = false;
      updateStickyVisibility();
    }, 1200);
    window.addEventListener('scroll', function() { requestAnimationFrame(updateStickyVisibility); }, { passive: true });
    window.addEventListener('resize', updateStickyVisibility);
  }

  // =====================
  // Cart drawer — remove item without leaving the page
  // The remove link is a plain <a href="/cart/change?...quantity=0">, which
  // does a full navigation to the cart page. The quantity +/- buttons in
  // this same drawer already update the cart via AJAX without navigating,
  // so route "remove" through that same input-change path (set quantity to
  // 0) rather than building a separate AJAX call.
  // =====================
  function initCartDrawerRemove() {
    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;
    cartDrawer.addEventListener('click', function(e) {
      var removeLink = e.target.closest('.cart__remove a');
      if (!removeLink) return;
      e.preventDefault();
      var item = removeLink.closest('.cart__item');
      var qtyInput = item ? item.querySelector('.js-qty__num') : null;
      if (!qtyInput) return;
      qtyInput.value = '0';
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // =====================
  // Mobile collection grid — 1 / 2 column toggle
  // Persists the chosen column count across collections via localStorage,
  // so the choice carries through when browsing to a different collection.
  //
  // The switch is deliberately INSTANT: one synchronous class flip on
  // <body>, nothing else. All the previous machinery — anchor-tile
  // tracking, settle-frame polling, scroll-position correction — has been
  // removed entirely; it was the source of the perceived drag/delay when
  // switching. While the reflow (including late image loads and Depict's
  // async re-rendering) plays out, a scoped .jci-no-transition class on
  // <body> holds transitions AND animations off inside the collection
  // grid for a fixed window so nothing in a tile can visibly slide or
  // fade around the change. On the initial page-load call the freeze is
  // kept very short so it can't suppress the swipe-hint nudge that fires
  // at 400ms.
  //
  // Image loading: the theme's images are lazysizes-driven (class=
  // "lazyload", data-src). lazysizes only rechecks which images are
  // eligible to fetch on scroll, resize, or a DOM mutation — a pure CSS
  // class flip fires none of those, so a tile that becomes newly visible
  // under the new column count could otherwise sit on its 1x1 placeholder
  // gif until the shopper happens to scroll. applyCols() forces an
  // immediate lazysizes recheck right after the class flip so anything
  // now within lazysizes' own expand threshold starts fetching the
  // instant the layout changes, instead of waiting on the next scroll.
  // =====================
  function initGridColumnToggle() {
    var STORAGE_KEY = 'jci-grid-cols';
    var toggle = document.querySelector('[data-jci-grid-toggle]');
    if (!toggle) return;

    var buttons = toggle.querySelectorAll('.jci-grid-toggle__btn');
    var liftTimer = null;

    function applyCols(cols, holdMs) {
      var bodyEl = document.body;

      // Freeze transitions/animations inside the grid before the layout
      // change commits, then flip the class — the reflow itself is a
      // single synchronous layout pass, so the new column count is on
      // screen at the very next paint.
      bodyEl.classList.add('jci-no-transition');
      void bodyEl.offsetHeight;

      bodyEl.classList.toggle('jci-grid-1col', cols === '1');
      buttons.forEach(function(btn) {
        var isActive = btn.getAttribute('data-grid-cols') === cols;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      // Nudge lazysizes to recheck right now — see comment above
      // initGridColumnToggle for why this is necessary.
      if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === 'function') {
        window.lazySizes.loader.checkElems();
      }

      if (liftTimer) clearTimeout(liftTimer);
      liftTimer = setTimeout(function() {
        bodyEl.classList.remove('jci-no-transition');
      }, holdMs);
    }

    var stored = null;
    try { stored = localStorage.getItem(STORAGE_KEY); } catch (e) {}
    if (stored === '1' || stored === '2') {
      applyCols(stored, 80);
    } else {
      // No explicit choice made yet on this device: fall back to the
      // per-collection default rendered server-side (Shop All / Sale
      // default to two-up, everything else to one-up — see
      // jci-grid-toggle.liquid). Once the person taps a button, that
      // becomes an explicit stored preference and carries through to
      // every collection from then on, overriding this default.
      var pageDefault = toggle.getAttribute('data-default-cols') === '2' ? '2' : '1';
      applyCols(pageDefault, 80);
    }

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var cols = btn.getAttribute('data-grid-cols');
        applyCols(cols, 1000);
        try { localStorage.setItem(STORAGE_KEY, cols); } catch (e) {}
      });
    });
  }

  initSwipeCarousels();
  runSwipeHint();
  initSizesLeftTouch();
  initProductBars();
  runProductSwipeHint();
  initStickyAddToCart();
  initCartDrawerRemove();
  initGridColumnToggle();

  document.addEventListener('collection:rerendered', function() { initSwipeCarousels(); runSwipeHint(); });
  window.addEventListener('popstate', function() { setTimeout(function() { initSwipeCarousels(); runSwipeHint(); }, 300); });
  var observer = new MutationObserver(function() {
    if (document.querySelectorAll('.jci-swipe:not([data-swipe-init])').length > 0) { initSwipeCarousels(); runSwipeHint(); }
  });
  observer.observe(document.body, { childList: true, subtree: true });

});
